/** Pasos del flujo, hijos de `/onboarding/:token` en `app.routes`. */
export type OnboardingStep = 'welcome' | 'rfc' | 'documents' | 'completed' | 'expired' | 'locked';

/**
 * Comandos de router para `/onboarding/{token}/{step}`. Es el único lugar, fuera de `app.routes`,
 * que conoce la forma de la URL. Devuelve comandos y no un string: el router encodea el token.
 * Sin token no hay flujo al que volver → `/not-found`.
 */
export function onboardingRoute(token: string | null, step: OnboardingStep): string[] {
  return token ? ['/onboarding', token, step] : ['/not-found'];
}
